import { useMutation } from '@tanstack/react-query'
import { resetPassword } from '../services/auth_service';

const useResetPassword = () => {
 const setNewPasswordMutation = useMutation({
    mutationFn: ({ token, password, confirmPassword }) => resetPassword(token, password, confirmPassword),
    onSuccess: (data) => {
    },
    onError: (error) => {
        console.error('Error setting new password:', error);
    }
 });
 
 return setNewPasswordMutation;
}

export default useResetPassword; 